export default __webpack_public_path__ + "static/media/Task_Filled_Active.b88f08f8.svg";